import React, { useState } from 'react';
import axios from 'axios';

import "./ForgotPassword.scss"

import closeIcon from '../../../../../Assets/images/close-icon.svg';
import nextIcon from '../../../../../Assets/images/next-icon.svg';
import mailIcon from '../../../../../Assets/images/mail-icon.svg';

import { isValidEmail } from '../../../../../Utils/Validations/validateEmail';
import Loader from '../../../../../Context/Loader/Loader';
import { FIELD_MAX_LENGTHS } from '../../Utils/Constants';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';

const basePath = process.env.REACT_APP_SERVER_BASE_URL;
const signInPath = process.env.REACT_APP_HS_SIGNIN_BASE_PATH;

const ForgotPassword = ({ onClose, onConfirmClose }) => {
    const [currentStep, setCurrentStep] = useState('form');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email.trim()) {
            setError('Email is required');
            return;
        }

        if (!isValidEmail(email)) {
            setError('Invalid email format');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${basePath}${signInPath}/forgot-password`,
                { email }
            );

            if (response.data.status === 'SUCCESS') {
                setCurrentStep('confirmation');
            } else {
                const msg = response.data?.message || response.data?.error_data?.message;
                showErrorToast(msg);
            }
        } catch (err) {
            const msg = err.response ? (err.response.data.message || err.response.data.error_data?.message) : err.message;
            console.error(msg);
            showErrorToast(msg);
        } finally {
            setLoading(false);
        }

    };

    return (
        <div className="form-outer">
            <form onSubmit={handleSubmit} noValidate>
                {currentStep === 'form' && (
                    <div className="page slide-page">
                        <div className="h-form signin-form">
                            <button className="close-button" type="button" onClick={onClose}>
                                <img src={closeIcon} alt="Close" />
                            </button>
                            <div className="otp-header">
                                <h1>Forgot Password?</h1>
                                <p className="fp-text">
                                    If you have forgot your password, it is easy to reset it.
                                    Just enter the email for your account.
                                </p>
                            </div>
                            <div className="hform-inner-small">
                                <div className="hf-split c-name">
                                    <label className="fi-label">
                                        Email address <span>*</span>
                                    </label>
                                    <input type="email" className={`common-input ${error ? 'error' : ''}`} placeholder="Enter your email" value={email} onChange={(e) => { setEmail(e.target.value); setError(''); }} maxLength={FIELD_MAX_LENGTHS.email} />
                                    <span className={`error-text ${error ? 'active' : ''}`} style={{ textTransform: 'none' }}>{error || ' '}</span>
                                </div>
                                <div className="field fp-field">
                                    <button type="submit" className="firstNext next h-btn right-btn" disabled={loading}  >
                                        {loading ? <Loader /> : <>Submit <img src={nextIcon} alt="Next" /></>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {currentStep === 'confirmation' && (
                    <div className="page">
                        <div className="h-form otp-form">
                            <div className="mail-image">
                                <img src={mailIcon} alt="Mail Icon" />
                            </div>
                            <div className="otp-header">
                                <h1>Check your email</h1>
                                <p className="fp-text">
                                    Please check your email inbox for instructions <br />
                                    to reset your password
                                </p>
                            </div>
                            <div className="hform-inner">
                                <div className="hotp-split mb-0">
                                    <div className="ob-cvr">
                                        <button type="button" className="h-btn ms-0 mt-0" onClick={onConfirmClose}>
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};

export default ForgotPassword;